export const INVENTORY_BASIC_SETUP_DATA = 'INVENTORY_BASIC_SETUP_DATA';
export const INVENTORY_BASIC_SETUP_LOADING_ERROR =
  'INVENTORY_BASIC_SETUP_LOADING_ERROR';
export const INVENTORY_BASIC_SETUP_CLEAR = 'INVENTORY_BASIC_SETUP_CLEAR';
export const INVENTORY_BASIC_SETUP_LOADING = 'INVENTORY_BASIC_SETUP_LOADING';
export const INVENTORY_BASIC_SUBMITTING_ERROR =
  'INVENTORY_BASIC_SUBMITTING_ERROR';
export const INVENTORY_BASIC_SUBMITTING = 'INVENTORY_BASIC_SUBMITTING';

export const INVENTORY_BASIC_SUBMITTED = 'INVENTORY_BASIC_SUBMITTED';



// WEBPACK FOOTER //
// ./src/pages/inventory/inventorybasicsetup/state/types.js